import React from "react";
import { iconStroke } from "../config/config";
import { Link, useLocation } from "react-router-dom";
import { clsx } from "clsx";
import { IconArmchair2, IconBook, IconCreditCard, IconDevices, IconInfoSquareRounded, IconLifebuoy, IconReceiptTax, IconGift, IconBed, IconRefresh, IconCoins, IconBuildingWarehouse } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useTheme } from "../contexts/ThemeContext";

const SafeIconPrinter = ({ size = 24, stroke = 2, className = "", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
    <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
    <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
    <path d="M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z" />
  </svg>
);


export default function SettingsNavbar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { theme } = useTheme();

  const items = [
    {
      icon: <IconInfoSquareRounded stroke={iconStroke} />,
      text: t("settings.details"),
      path: "/dashboard/settings",
    },
    {
      icon: <IconBuildingWarehouse stroke={iconStroke} />,
      text: "Branches",
      path: "/dashboard/settings/branches",
    },
    {
      icon: <IconRefresh stroke={iconStroke} />,
      text: "Workflow & Sync",
      path: "/dashboard/settings/workflow",
    },
    {
      icon: <SafeIconPrinter stroke={iconStroke} />,
      text: t("settings.print_settings"),
      path: "/dashboard/settings/print-settings",
    },
    {
      icon: <IconArmchair2 stroke={iconStroke} />,
      text: t("settings.tables"),
      path: "/dashboard/settings/tables",
    },
    {
      icon: <IconBed stroke={iconStroke} />,
      text: "Rooms Settings",
      path: "/dashboard/settings/rooms",
    },
    {
      icon: <IconBook stroke={iconStroke} />,
      text: t("settings.menu_items"),
      path: "/dashboard/settings/menu-items",
    },
    {
      icon: <IconReceiptTax stroke={iconStroke} />,
      text: t("settings.tax_setup"),
      path: "/dashboard/settings/tax-setup",
    },
    {
      icon: <IconCreditCard stroke={iconStroke} />,
      text: t("settings.payment_types"),
      path: "/dashboard/settings/payment-types",
    },
    {
      icon: <IconGift stroke={iconStroke} />,
      text: "Loyalty Program",
      path: "/dashboard/settings/loyalty",
    },
    {
      icon: <IconCoins stroke={iconStroke} />,
      text: "Currencies & Denominations",
      path: "/dashboard/settings/currencies",
    },
    {
      icon: <SafeIconPrinter stroke={iconStroke} />,
      text: "Printers",
      path: "/dashboard/settings/printers",
    },
    // {
    //   icon: <IconDevices stroke={iconStroke} />,
    //   text: "Devices",
    //   path: "/dashboard/settings/devices",
    // },
    // {
    //   icon: <IconLifebuoy stroke={iconStroke} />,
    //   text: "Contact Support",
    //   path: "/dashboard/settings/contact-support",
    // },
  ];

  return (
    <div className='w-20 md:w-60 h-full overflow-y-auto border-r md:px-4 py-3 flex items-center flex-col gap-1 md:gap-3 sticky  left-0 top-20 border-restro-border-green'>
      {items.map((item, index) => {
        const isActive = item.path === pathname || 
          (item.path === "/dashboard/settings" && (pathname === "/dashboard/settings" || pathname === "/dashboard/settings/details" || pathname === "/dashboard/settings/store-details")) ||
          (item.path === "/dashboard/settings/workflow" && (pathname === "/dashboard/settings/workflow" || pathname === "/dashboard/settings/application-workflow" || pathname === "/dashboard/settings/sync"));
        return (
          <Link
            to={item.path}
            key={index}
            className={clsx(
              "w-12 h-12 md:w-full md:h-auto md:min-w-fit flex items-center justify-center md:justify-normal gap-1 md:px-4 md:py-3 rounded-full transition group",
              isActive
                ? theme === "black"
                  ? "bg-[#353535] text-white font-medium"
                  : "bg-restro-border-green-light font-medium text-restro-green-dark"
                : theme === "black"
                  ? "text-white hover:bg-[#353535]"
                  : "text-restro-green-dark hover:bg-restro-border-green-light"
            )}
          >
            <span className={clsx(
              "transition-colors",
              isActive
                ? theme === "black" ? "text-white" : "text-restro-green-dark"
                : theme === "black"
                  ? "text-white"
                  : ""
            )}>
              {React.cloneElement(item.icon, {
                className: "w-6 h-6",
              })}
            </span>
            <p className={clsx(
              "hidden md:block transition-colors",
              isActive
                ? theme === "black" ? "text-white" : "text-restro-green-dark"
                : theme === "black"
                  ? "text-white"
                  : ""
            )}>
              {item.text}
            </p>
          </Link>
        );
      })}
    </div>
  );
}
